import {useRouter} from '@s-ui/react-router'

import {ROUTES} from '../../../../../config/index.js'

export const useNavigationTransactionBuyerCheckCostsList = () => {
  const {push} = useRouter()

  const navigation = interactionUrl => {
    const {searchParams} = new URL(interactionUrl)
    const tradeId = searchParams.get('tradeId')
    const adId = searchParams.get('adId')

    push(`${ROUTES.TRANSACTION.BUYER_CHECK_COSTS_LIST}?tradeId=${tradeId}&adId=${adId}`)
  }

  return navigation
}
